module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "alsoby"
  }, [_c('a', {
    attrs: {
      "id": "title13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Books by Helen Brooks")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_vm._v("HARLEQUIN ROMANCE "), _c('br'), _vm._v("3350—AND THE BRIDE WORE BLACK "), _c('br'), _vm._v("3378—ANGELS DO HAVE WINGS "), _c('br'), _vm._v("3434—DREAM WEDDING")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_vm._v("HARLEQUIN PRESENTS "), _c('br'), _vm._v("1844—A HEARTLESS MARRIAGE "), _c('br'), _vm._v("1934—HUSBAND BY CONTRACT "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(Husbands & Wives #1)")]), _vm._v(" "), _c('br'), _vm._v("1939—SECOND MARRIAGE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(Husbands & Wives #2)")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Don’t miss any of our special offers. Write to us at the following address for information on our newest releases.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Harlequin Reader Service")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("U.S.: 3010 Walden Ave., P.O. Box 1325, Buffalo, NY 14269")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Canadian: P.O. Box 609, Fort Erie, Ont. L2A 5X3")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d73ba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459263314_als01.vue
// module id = 66
// module chunks = 0